import React from 'react';
import { Highlight } from 'prism-react-renderer';
import { CopyButton } from '../shared/CopyButton';
import styles from './CodeBlock.module.css';

const theme = {
  plain: {
    color: '#2e2e2c',
    backgroundColor: 'transparent',
  },
  styles: [
    {
      types: ['comment', 'prolog', 'doctype', 'cdata'],
      style: { color: '#9a9a93', fontStyle: 'italic' as const },
    },
    {
      types: ['punctuation'],
      style: { color: '#6e6e68' },
    },
    {
      types: ['keyword', 'tag', 'selector', 'important', 'atrule'],
      style: { color: '#7b5ea7' },
    },
    {
      types: ['string', 'char', 'attr-value', 'regex', 'url'],
      style: { color: '#5a7e3e' },
    },
    {
      types: ['number', 'boolean', 'constant'],
      style: { color: '#9c6b30' },
    },
    {
      types: ['function', 'class-name', 'builtin'],
      style: { color: '#4078a0' },
    },
    {
      types: ['attr-name', 'property'],
      style: { color: '#9c6b30' },
    },
    {
      types: ['operator'],
      style: { color: '#6e6e68' },
    },
    {
      types: ['variable'],
      style: { color: '#2e2e2c' },
    },
  ],
};

interface CodeBlockProps {
  language: string;
  title?: string;
  children: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ language, title, children }) => {
  return (
    <div className={styles.shell}>
      <div className={styles.header}>
        <span className={styles.lang}>{language}</span>
        <div className={styles.headerRight}>
          {title && <span className={styles.title}>{title}</span>}
          <CopyButton value={children} aria-label="Copy code" />
        </div>
      </div>
      <div className={styles.body}>
        <Highlight code={children.trimEnd()} language={language.toLowerCase()} theme={theme}>
          {({ tokens, getLineProps, getTokenProps }) => (
            <pre className={styles.code}>
              {tokens.map((line, i) => (
                <div key={i} {...getLineProps({ line })}>
                  {line.map((token, key) => (
                    <span key={key} {...getTokenProps({ token })} />
                  ))}
                </div>
              ))}
            </pre>
          )}
        </Highlight>
      </div>
    </div>
  );
};
